/**
 * https://www.osano.com/cookieconsent/download/
 */
window.cookieconsent.initialise({
    "palette": {
        "popup": {
            "background": "#c38246",
            "text": "#ffffff"
        },
        "button": {
            "background": "#c38246",
            "border": "#ffffff",
            "text": "#ffffff"
        }
    },
    "content": {
        "message": "Auf dieser Webseite werden zur Verbesserung der Funktionalität und des Leistungsverhaltens Cookies eingesetzt. " +
            "Durch Klicken auf den OK-Button stimmen Sie der Verwendung von Cookies auf dieser Webseite zu.\n",
        "dismiss": "OK",
        "link": "Weitere Informationen",
        "href": "https://www.phlu.ch/impressum.html"
    }
});
